import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { withFormikField, getFormikError } from 'utils/formik';
import { Field } from '@ontruck/orc';
import { injectIntl } from 'react-intl';
const StyledField = styled(Field)`
  width: 100%;
`;

const Locator = ({ field, form, intl, ...props }) => {
  const { value } = field;
  const t = intl.messages.modules.locator;
  return (
    <StyledField
      {...props}
      label={t.label}
      value={value}
      error={false}
      invalid={!!getFormikError({ field, form })}
    />
  );
};

Locator.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

Locator.defaultProps = {
  field: 'locator',
};

export default withFormikField(injectIntl(Locator));
